import React from 'react';
import { Button, ButtonToolbar, Card, CardBody, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../../../../../utils/helpers';
import validate from './validate';

const AddNewApiKeyForm = ({ handleSubmit }) => {
  return (
    <Card>
      <CardBody>
        <form className="form" onSubmit={handleSubmit}>
          <Col className="col-12">
            <div className="form__form-group">
              <span className="form__form-group-label">Resource name</span>
              <div className="form__form-group-field">
                <Field
                  name="name"
                  component={renderField}
                  type="text"
                  label="e.g. skynix.com landing page"
                />
              </div>
            </div>
          </Col>
          <Col className="col-12">
            <div className="form__form-group">
              <span className="form__form-group-label">Domain</span>
              <div className="form__form-group-field">
                <Field
                  name="domain"
                  component={renderField}
                  type="text"
                  label="e.g. skynix.com"
                />
              </div>
            </div>
          </Col>
          <Col className="col-12">
            <ButtonToolbar className="form__button-toolbar d-flex w-100 justify-content-end">
              <Button color="primary" type="submit">Generate API key</Button>
            </ButtonToolbar>
          </Col>
        </form>
      </CardBody>
    </Card>
  );
};

export default reduxForm({
  form: 'add_new_lead_api_key_form',
  validate,
})(AddNewApiKeyForm);
